import { v_DispatchNoteBus } from './v_DispatchNoteBus';
import { v_DispatchAttachmentBus } from './v_DispatchAttachmentBus';
import { BaseBus } from './BaseBus';
import { CommonFunctions } from '../static/common-functions';
import { DispatchRefTrackingBus } from './DispatchRefTrackingBus';

export class AdditionalDispatchData extends BaseBus {
    constructor(data: AdditionalDispatchData = null) {
        super(data);
        if (CommonFunctions.hasValue(data)) {
            if (CommonFunctions.hasArrayValue(data.dispatchNotes)) {
                let notes: v_DispatchNoteBus[] = [];
                let notesInjury: v_DispatchNoteBus[] = [];
                for (let i = 0; i < data.dispatchNotes.length; i++) {
                    let newData: v_DispatchNoteBus = new v_DispatchNoteBus(data.dispatchNotes[i]);
                    if (newData.isWarning) {
                        notesInjury.push(newData);
                    }
                    else {
                        notes.push(newData);
                    }
                }
                this.dispatchNotes = notes;
                this.dispatchNotesInjury = notesInjury;
            }
            this.acctMgr = data.acctMgr;
            this.invoiceNumber = data.invoiceNumber;
            this.quoteNumber = data.quoteNumber;
            let arrRefTrk = [];
            if (CommonFunctions.hasArrayValue(data.refTracking)) {
                for (let i = 0; i < data.refTracking.length; i++) {
                    let refTrkData = new DispatchRefTrackingBus(data.refTracking[i]);
                    arrRefTrk.push(refTrkData);
                }
                this.refTracking = arrRefTrk;
            }
            this.regionName = data.regionName;
        }
    }
    getRefTrackingStatus(): number { //0-No Recrods, 1-Has Records no complete, 2-Complete
        let status: number = 0;
        if (CommonFunctions.hasArrayElementValue(this.refTracking)) {
            status = 1;
            let compl = this.refTracking.filter(s => s.isComplete == true);
            if (CommonFunctions.hasArrayElementValue(compl)) {
                status = 2;
            }
        }
        return status;
    }
    clear() {
        this.acctMgr = "";
        this.quoteNumber = "";
        this.invoiceNumber = "";
        this.profit1 = null;
        this.profit2 = null;
        this.callbackNumber = null;
        this.dispatchNotes = null;
        this.dispatchNotesInjury = null;
        this.dispatchAttachments = null;
        this.dispatchAttachmentDetails = null;
        this.refTracking = null;
        this.regionName = "";
    }
    acctMgr: string = "";
    quoteNumber: string = "";
    invoiceNumber: string = "";
    profit1: number;
    profit2: number;
    callbackNumber: string;
    dispatchNotes: v_DispatchNoteBus[];
    dispatchNotesInjury: v_DispatchNoteBus[];
    dispatchAttachments: v_DispatchAttachmentBus[];
    dispatchAttachmentDetails: v_DispatchAttachmentBus[];
    refTracking: DispatchRefTrackingBus[];
    regionName: string = "";
    fieldInvoiceQueueId: string;
    //get dispatchNotesNonInjury(): v_DispatchNoteBus[] {
    //    let notes: v_DispatchNoteBus[] = [];
    //    if (CommonFunctions.hasArrayValue(this.dispatchNotes)) {
    //        return this.dispatchNotes.filter(x => x.isWarning === false);
    //    }
    //}
    //get dispatchNotesInjury(): v_DispatchNoteBus[] {
    //    let notes: v_DispatchNoteBus[] = [];
    //    if (CommonFunctions.hasArrayValue(this.dispatchNotes)) {
    //        return this.dispatchNotes.filter(x => x.isWarning === true);
    //    }
    //}
}
